import React from 'react';
import AuthService from '../authService.js';
import GroupMemberItem from '../../Domain/UserGroup/GroupMemberItem.js';
import SearchParams from '../../Elements/SearchParams';
import GroupMemberSearchParams from '../../Contents/Administration/UserGroups/GroupMemberSearchParams';

export default class GroupMemberService extends React.Component {
  static GetAllItemsBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, GroupMemberSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/UserGroup/GetGroupMembers/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }

  static AddGroupMembers(item) {
    const url = '/api/UserGroup/AddGroupMembers';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost(url, item);
  }

  static RemoveGroupMembers(userIds, groupId) {
    // userIds should be an array of numbers
    const userIdsParam = userIds.join(',');
    const url = `/api/UserGroup/RemoveGroupMembers?groupId=${encodeURIComponent(groupId)}&userIds=${encodeURIComponent(
      userIdsParam
    )}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionDelete(url);
  }

  static ConvertDBItems(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new GroupMemberItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }
}
